export default __webpack_public_path__ + "static/media/MarkerIconYellow.1e28d6d3.svg";